const fetchGraphql = async ({query, variables}) => {
  const STOREFRONT_TOKEN = "225376cfdc26018260a0dfec258cf5c7";
  const URL = "/api/2024-01/graphql.json";

  const response = await fetch(URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
    },
    body: JSON.stringify({
      query: query,
      variables: {
        ...variables
      }
    })
  });

  const data = await response.json();
  return data;
};

export default fetchGraphql;
